"use strict";
/**
 * @license
 * Copyright 2019 The Neuroglancer Authors
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { makeSliceViewChunkSpecification } from "#src/sliceview/base.js";
import { Uint64 } from "#src/util/uint64.js";
export const PYCG_APP_VERSION = 1;
export const GRAPHENE_MESH_NEW_SEGMENT_RPC_ID = "GrapheneMeshSource:NewSegment";
export var VolumeChunkEncoding = /* @__PURE__ */ ((VolumeChunkEncoding2) => {
  VolumeChunkEncoding2[VolumeChunkEncoding2["RAW"] = 0] = "RAW";
  VolumeChunkEncoding2[VolumeChunkEncoding2["JPEG"] = 1] = "JPEG";
  VolumeChunkEncoding2[VolumeChunkEncoding2["COMPRESSED_SEGMENTATION"] = 2] = "COMPRESSED_SEGMENTATION";
  return VolumeChunkEncoding2;
})(VolumeChunkEncoding || {});
export class VolumeChunkSourceParameters {
  static {
    this.RPC_ID = "graphene/VolumeChunkSource";
  }
}
export class ChunkedGraphSourceParameters {
  static {
    this.RPC_ID = "graphene/ChunkedGraphSource";
  }
}
export class MeshSourceParameters {
  static {
    this.RPC_ID = "graphene/MeshSource";
  }
}
export class MultiscaleMeshMetadata {
}
export const responseIdentity = async (x) => x;
export function isBaseSegmentId(segmentId, nBitsForLayerId) {
  const layerId = Uint64.rshift(new Uint64(), segmentId, 64 - nBitsForLayerId);
  return Uint64.equal(layerId, Uint64.ONE);
}
export function getGrapheneFragmentKey(fragmentId) {
  const sharded = fragmentId.charAt(0) === "~";
  if (sharded) {
    const parts = fragmentId.substring(1).split(/:(.+)/);
    return { key: parts[0], fragmentId: parts[1] };
  }
  return { key: fragmentId, fragmentId };
}
export const CHUNKED_GRAPH_LAYER_RPC_ID = "ChunkedGraphLayer";
export const CHUNKED_GRAPH_RENDER_LAYER_UPDATE_SOURCES_RPC_ID = "ChunkedGraphLayer:updateSources";
export const RENDER_RATIO_LIMIT = 5;
export function makeChunkedGraphChunkSpecification(options) {
  const { rank, dataType } = options;
  const { baseVoxelOffset = new Float32Array(rank) } = options;
  return {
    ...makeSliceViewChunkSpecification(options),
    baseVoxelOffset,
    dataType
  };
}
